export const updateSortResetLink = (searchParams)=>{
    const sortResetLink = document.querySelector('.js-sort-reset a');
    if (sortResetLink instanceof HTMLAnchorElement) {
        if (sortResetLink) {
            const baseUrl = window.location.pathname;
            const params = new URLSearchParams(searchParams);
            // Remove the sort_by param from the filter reset link
            params.delete('sort_by');
            // Construct the updated filter reset URL
            const sortResetUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
            sortResetLink.href = sortResetUrl;
        }
    }
};
export const updateFiltersResetLink = (searchParams)=>{
    const filterResetLink = document.querySelector('.js-filter-reset a');
    if (filterResetLink instanceof HTMLAnchorElement) {
        if (filterResetLink) {
            const baseUrl = window.location.pathname;
            const params = new URLSearchParams(searchParams);
            const keysToDelete = new Set();
            params.forEach((_, key)=>{
                if (key.includes('filter.')) {
                    keysToDelete.add(key);
                }
            });
            // keys are grouped so if you have multiple occurrencies for filter.p.m.custom.colors_list eg:
            // filter.p.m.custom.colors_list=Coral&filter.p.m.custom.colors_list=Green&filter.p.m.custom.colors_list=Navy&filter.p.m.custom.fabric=DreamModal
            // this will result in only two keys to delete
            // filter.p.m.custom.colors_list and filter.p.m.custom.fabric
            keysToDelete.forEach((key)=>params.delete(key));
            // Construct the sort reset URL
            const filterResetUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
            filterResetLink.href = filterResetUrl;
        }
    }
};
